export const INVENTORY_STORAGE_DIM_COLUMNS = [
  {
    Header: "Location",
    accessor: "CompanyLocation.Name",
    id: "CompanyLocRecIdRef"
  },
  {
    Header: "Name",
    accessor: "InvStorageType.CodeDescription",
    id: "CodeDescription"
  },
  {
    Header: "Code",
    accessor: "DimCode",
    id: "Code"
  },
  {
    Header: "Description",
    accessor: "DimDescription",
    id: "Description"
  },
  {
    Header: "Active",
    accessor: "Active",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  }
];
